<mat-card-content>
  <div class="table-responsive">
    <table *ngIf="dataSourceOwners?.data?.length > 0" mat-table [dataSource]="dataSourceOwners" class="mat-elevation-z8">

      <ng-container matColumnDef="aval">
        <th mat-header-cell *matHeaderCellDef class="th-title" style="text-align: center;">AVAL</th>
        <td mat-cell *matCellDef="let element" class="td-text-content" 
            [matTooltip]="minuteRequestRealTime?.isClosed ? '' : 'Cambiar estado'">
          <div *ngIf="!showAvalSpinner(element.fullRut); else spinner">
            <span *ngIf="element.aval"
                  (click)="handleClick(element.fullRut, element.aval)"
                  [ngClass]="{'disabled': isDisabled() || minuteRequestRealTime?.isClosed}" 
                  class="status-icon green">
              <fa-icon [icon]="icons.faCircleCheck"></fa-icon>
            </span>
            <span *ngIf="!element.aval"
                  (click)="handleClick(element.fullRut, element.aval)"
                  [ngClass]="{'disabled': isDisabled() || minuteRequestRealTime?.isClosed}" 
                  class="status-icon red">
              <fa-icon [icon]="icons.faCircleXmark"></fa-icon>
            </span>
          </div>
        </td>
        <ng-template #spinner>
          <mat-spinner [diameter]="30"></mat-spinner>
        </ng-template>
      </ng-container>
      

      <ng-container matColumnDef="rl">
        <th mat-header-cell *matHeaderCellDef class="th-title" style="text-align: center;">RL</th>
        <td mat-cell *matCellDef="let element" class="td-text-content" 
            [matTooltip]="minuteRequestRealTime?.isClosed ? '' : 'Cambiar estado'">
          <div *ngIf="!showRlSpinner(element.fullRut); else spinner">
            <span *ngIf="element.rl" 
                  (click)="handleRlClick(element.fullRut, element.rl)"
                  [ngClass]="{'disabled': isDisabled() || minuteRequestRealTime?.isClosed}" 
                  class="status-icon green">
              <fa-icon [icon]="icons.faCircleCheck"></fa-icon>
            </span>
            <span *ngIf="!element.rl" 
                  (click)="handleRlClick(element.fullRut, element.rl)"
                  [ngClass]="{'disabled': isDisabled() || minuteRequestRealTime?.isClosed}" 
                  class="status-icon red">
              <fa-icon [icon]="icons.faCircleXmark"></fa-icon>
            </span>
          </div>
        </td>
      </ng-container>
      

      <ng-container matColumnDef="participation">
        <th mat-header-cell *matHeaderCellDef class="th-title">Participacion</th>
        <td mat-cell *matCellDef="let element">
          {{ element.participation ? element.participation + '%' : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="nameAndRut">
        <th mat-header-cell *matHeaderCellDef class="th-title">Socio</th>
        <td mat-cell *matCellDef="let element">
          {{ element.name || '-' }} {{ element.lastName || '-' }} <br>
          {{ element.fullRut }}
        </td>
      </ng-container>

      <ng-container matColumnDef="age">
        <th mat-header-cell *matHeaderCellDef class="th-title">Edad</th>
        <td mat-cell *matCellDef="let element">
          {{ element.age || '-' }} Años
        </td>
      </ng-container>

      <ng-container matColumnDef="civilState">
        <th mat-header-cell *matHeaderCellDef class="th-title">Estado Civil</th>
        <td mat-cell *matCellDef="let element">
          {{ element.civilState || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="dicom">
        <th mat-header-cell *matHeaderCellDef class="th-title">Dicom</th>
        <td mat-cell *matCellDef="let element">
          <div *ngIf="element.dicom !== undefined; else notDicom">
            {{ element.puntajeEquifax ? ('Puntaje: ' + element.puntajeEquifax) : 'S/Info' }} <br>
            {{ element.dicom | currency:'CLP':'symbol' }}
          </div>
          <ng-template #notDicom>S/info</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="amountVigenteCmf">
        <th mat-header-cell *matHeaderCellDef class="th-title">SBIF</th>
        <td mat-cell *matCellDef="let element">
          {{ element.amountVigenteCmf ? (element.amountVigenteCmf | currency:'CLP':'symbol') : '-' }} /Vig.  <br >
          {{ element.amountMorosaCmf ? (element.amountMorosaCmf | currency:'CLP':'symbol') : '-' }} /Mor.
        </td>
      </ng-container>

      <ng-container matColumnDef="autos">
        <th mat-header-cell *matHeaderCellDef class="th-title">Autos</th>
        <td mat-cell *matCellDef="let element">
          {{ element.cantidadTotalCars ? element.cantidadTotalCars : '-' }}  <br >
          {{ element.totalAmountCars ? element.totalAmountCars : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="propiedades">
        <th mat-header-cell *matHeaderCellDef class="th-title">Propiedades</th>
        <td mat-cell *matCellDef="let element">
          {{ element.cantidadTotalPropiedades ? element.cantidadTotalPropiedades : '-' }}  <br >
          {{ element.totalAmountPropiedades ? element.totalAmountPropiedades : '-' }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsOwners"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsOwners"></tr>
    </table>

    <div *ngIf="dataSourceOwners?.data?.length === 0">
      <h3 style="text-align: center;">No se encontraron Socios</h3>
    </div>
  </div>
</mat-card-content>
